import { useState } from "react";
import { Sun } from "lucide-react";
import { useLanguage } from "../i18n/translations";

const BRANDS = [
  { name: "Adani Solar", logo: "/brands/adani-solar.png" },
  { name: "Tata Power Solar", logo: "/brands/tata-power-solar.png" },
  { name: "Waaree", logo: "/brands/waaree.png" },
  { name: "Luminous", logo: "/brands/luminous.svg" },
  { name: "Livguard", logo: "/brands/livguard.svg" },
  { name: "Avaada", logo: "/brands/avaada.png" },
  { name: "Microtek", logo: "/brands/microtek.svg" },
  { name: "UTL Solar", logo: "/brands/utl-solar.png" },
  { name: "Premier Energies", logo: "/brands/premier-energies.png" },
];

const BrandBadge = ({ brand, copy }) => {
  const [imgOk, setImgOk] = useState(Boolean(brand.logo));
  const id = `${brand.name.toLowerCase().replace(/\s+/g, "-")}${copy ? "-copy" : ""}`;
  if (imgOk) {
    return (
      <span className="flex h-20 w-52 shrink-0 items-center justify-center rounded-lg border border-black/10 bg-[#FFFFFF] px-5 py-3">
        <img
          src={brand.logo}
          alt={copy ? "" : brand.name}
          className="h-14 w-full object-contain"
          width="168"
          height="56"
          onError={() => setImgOk(false)}
          data-testid={`brand-logo-${id}`}
        />
      </span>
    );
  }
  return (
    <span
      className="whitespace-nowrap font-display text-xl font-extrabold uppercase tracking-wide text-slate-500 transition-colors duration-300 hover:text-solar-highlight sm:text-2xl"
      data-testid={`brand-badge-${id}`}
    >
      {brand.name}
    </span>
  );
};

export const BrandMarquee = () => {
  const { t } = useLanguage();

  return (
    <section className="border-y border-white/10 bg-navy-900/50 py-8" data-testid="brand-marquee">
      <p className="mb-6 px-4 text-center text-xs font-semibold uppercase tracking-[0.3em] text-slate-500" data-testid="brand-marquee-heading">
        {t.brands.eyebrow}
      </p>
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-8 bg-gradient-to-r from-navy-950 to-transparent sm:w-24" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-8 bg-gradient-to-l from-navy-950 to-transparent sm:w-24" />
        <div className="brand-marquee-track flex w-max animate-marquee items-center hover:[animation-play-state:paused]">
          {[false, true].map((copy) => (
            <div key={String(copy)} aria-hidden={copy || undefined} className="brand-marquee-group flex shrink-0 items-center gap-12 pr-12">
              {BRANDS.map((brand) => (
                <div key={brand.name} className="flex shrink-0 items-center gap-12">
                  <BrandBadge brand={brand} copy={copy} />
                  <Sun size={16} aria-hidden="true" className="shrink-0 text-solar/50" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
